/**
 * 词典难度等级(C 端): 句子内单词高亮配色.
 *
 * 与后端 app/models/plan.py 的 DIFFICULTY_* 对齐, 与 admin/src/lib/difficulty.ts 同语义:
 * 初阶绿 / 中阶蓝 / 高阶橙, 空串 = 未分类。
 */

/** 行内高亮配色(soft): 用低透明度底 + 同色文字 */
const HIGHLIGHT: Record<string, string> = {
  beginner: 'bg-success/10 text-success',
  intermediate: 'bg-primary/10 text-primary',
  advanced: 'bg-warning/10 text-warning',
}

const DEFAULT_HIGHLIGHT = 'bg-primary/10 text-primary'

/** 句子中高亮词的样式 */
export function highlightClass(value: string): string {
  return HIGHLIGHT[value] ?? DEFAULT_HIGHLIGHT
}
